
class ChangeReasonModalController {

    $onInit() {
        this.changeReasonList = this.resolve.changeReasonList;
        this.selectedChangeReason = null;
        this.explanation = '';
    }

    closeModal() {
        this.modalInstance.close();
    }

    setChangeReason(selectedReason) {
        this.selectedChangeReason = selectedReason;
    }

    saveModal() {
        this.resolve.parentController.saveWithChange(this.selectedChangeReason, this.explanation);
        this.modalInstance.close();
    }

}

export default ChangeReasonModalController;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/change-reason-modal/change-reason-modal-controller.js